<template>
	<div>
		<div class="container">
			<div class="handle-box">
				<el-input size="small" v-model="query.uid" clearable maxlength="12" placeholder="序号"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-input size="small" v-model="query.batchNum" clearable maxlength="12" placeholder="批次号"
					style="width: 180px;" class="handle-input mr10"></el-input>
				<el-select size="small" v-model="query.status" filterable clearable placeholder="是否入库"
					class="handle-select mb10 m_r_10">
					<el-option v-for="item in storeList" :key="item.value" :label="item.label"
						:value="item.value"></el-option>
				</el-select>
				<el-date-picker v-model="timeArr" type="daterange" unlink-panels range-separator="至"
					start-placeholder="开始日期" end-placeholder="结束日期" @change="getTime" size="small"
					style="width: 260px;margin-right: 10px;"></el-date-picker>
				<el-button size="small" type="primary" :class="[theme]" @click="getData" icon="el-icon-search"
					:loading="loading">搜索</el-button>
			</div>
			<el-table :data="tableData" border class="table" ref="multipleTable" header-cell-class-name="table-header"
				max-height="600" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe v-loading="loading">
				<el-table-column prop="uid" label="序号" align="center"></el-table-column>
				<el-table-column prop="batch_num" label="批次号" align="center"></el-table-column>
				<el-table-column prop="cardName" label="品牌" align="center" width="100"></el-table-column>
				<el-table-column prop="standard" label="制式" align="center"></el-table-column>
				<el-table-column prop="count" label="数量" align="center"></el-table-column>
				<el-table-column label="操作" width="260" align="center">
					<template #default="scope">
						<el-button size="small" type="text" v-if="scope.row.status!==2"
							@click="handleAdd(scope.row)">写卡</el-button>
						<el-button size="small" type="text" @click="importProgress(scope.row)">记录</el-button>
					</template>
				</el-table-column>
			</el-table>

			<div class="pagination">
				<el-pagination background layout="total, sizes, prev, pager, next, jumper"
					:page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="query.pageSize" :total="pageTotal"
					@current-change="handlePageChange" @size-change="handleSizeChange"></el-pagination>
			</div>
		</div>

		<el-dialog title="添加" v-model="addVisible" width="550px" @close="closeDialog" class="customer">
			<el-form label-width="120px" :model="addForm" ref="addForm">
				<el-form-item label="上传文件" prop="minutes">
					<el-upload ref="upload" action="/api/sjtxCardImport/whiteCardWrite" :headers="token" :limit="1"
						:on-success="uploadSuccess" :on-preview="handlePreview" :on-remove="handleRemove"
						:auto-upload="false" :data="addForm">
						<el-button size="small" type="primary" :class="[theme]"
							style="margin-top: 40px;">选择文件</el-button>
						<div class="el-upload__tip">只能导入excel文件</div>
					</el-upload>
				</el-form-item>

				<el-form-item label="套餐" prop="setMealId">
					<el-select size="small" v-model="addForm.setMealId" clearable filterable placeholder="请选择套餐"
						style="width: 100%;">
						<el-option v-for="item in setMealIdList" :key="item.name" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item class="dis-end">
					<el-button size="small" @click="closeDialog">取消</el-button>
					<el-button size="small" type="primary" :class="[theme]" @click="submitAdd"
						:loading="uploading">写卡</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>

		<el-dialog title="进度" v-model="progressVisible" width="1200px" @close="closeDialog">
			<el-table :data="progressTableData" border class="table" ref="multipleTable"
				header-cell-class-name="table-header" :row-style="{ height: '20px' }" :cell-style="{ padding: '6px' }"
				:header-cell-style="{ 'text-align': 'center' }" stripe>
				<el-table-column prop="uid" label="序号" align="center" width="60"></el-table-column>
				<el-table-column prop="batchNum" label="批次号" align="center"></el-table-column>
				<el-table-column prop="total" label="入库数量" align="center" width="100"></el-table-column>
				<el-table-column prop="sus" label="成功" align="center" width="100"></el-table-column>
				<el-table-column prop="fail" label="失败" align="center" width="100"></el-table-column>
				<el-table-column prop="operator" label="操作人" align="center" width="120"></el-table-column>
				<el-table-column prop="" label="进度" align="center">
					<template #default="scope">
						<el-progress
							:percentage="Math.round(((scope.row.sus+scope.row.fail)/scope.row.total)*100)"></el-progress>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="时间" align="center" width="160"></el-table-column>
				<el-table-column label="操作" width="100" align="center">
					<template #default="scope">
						<a :href="scope.row.reportPath" v-if="scope.row.reportPath" style="color: #66b1ff;">下载</a>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>



	</div>
</template>

<script>
	import {
		whiteCardStatistics,
		whiteCardWrite,
		closeOrder,
		importOrderRecord,
		submitOrder,
		setMealList
	} from '../api/SjtxCard.js';
	import {
		getCardType
	} from '../api/cardType.js';

	export default {
		name: 'whiteCard',
		data() {
			// 订单表单验证规则
			const validateNumber = (rule, value, callback) => {
				if (value === '' || value === null) {
					callback(new Error('不能为空'));
				} else if (isNaN(value) || value < 0) {
					callback(new Error('请输入有效数字'));
				} else {
					callback();
				}
			};

			return {
				loading: false,
				uploading: false,
				theme: localStorage.getItem('theme'),
				theme3: localStorage.getItem('theme3'),
				theme8: localStorage.getItem('theme8'),
				query: {
					userId: localStorage.getItem('user'),
					pageIndex: 1,
					pageSize: 10,
					uid: '',
					startTime: '',
					endTime: '',
					batchNum: '',
					status: ''
				},
				tableData: [],
				pageTotal: 0,
				addVisible: false,
				addForm: {
					file: null,
					cardId: '',
					uid: '',
					standard: '',
					batchNum: '',
					batchOpen: false,
				},
				storeList: [{
						value: '1',
						label: '待入库'
					},
					{
						value: '2',
						label: '已入库'
					}
				],
				standardList: ['联通', '电信', '移动', ],
				setMealIdList: [], //套餐
				cardsList: [], //品牌
				timeArr: [],
				uid: '',
				progressVisible: false,
				progressTableData: [],
				setSecondstimer: null,
				addOrderForm: {
					yd: null,
					lt: null,
					dx: null,
					type: null,
					cardId: "",
					price: null,
				},
				token: {
					Authorization: localStorage.getItem('token'),
					type: 'web',
					UserRole: localStorage.getItem('ms_role'),
					XSecurityVersion: 'v2'
				},
				path: process.env.BASE_URL,

				// 订单表单验证规则
				orderRules: {
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}],
					cardId: [{
						required: true,
						message: '请选择品牌',
						trigger: 'change'
					}],
					price: [{
						required: true,
						validator: validateNumber,
						trigger: 'blur'
					}],
					lt: [{
						required: true,
						validator: validateNumber,
						trigger: 'blur'
					}],
					yd: [{
						required: true,
						validator: validateNumber,
						trigger: 'blur'
					}],
					dx: [{
						required: true,
						validator: validateNumber,
						trigger: 'blur'
					}]
				},
			};
		},

		created() {
			this.getData();
			this.getCardType();
			this.updatePaginationStyle();
		},
		methods: {
			updatePaginationStyle() {
				let pagination = document.getElementById('pagination');
				if (!pagination) {
					pagination = document.createElement('style');
					pagination.id = 'dynamic-tab-style';
					document.head.appendChild(pagination);
				}
				pagination.innerHTML = `
				    .el-pager .active {
				        background-color: ${this.theme8} !important;
						color: #fff !important;
				    }
					.el-pager .number:hover {
				        color: ${this.theme8} !important;
				    }
					.el-pager .active:hover {
					    color: #fff !important;
					}
					.el-pager .more:hover {
					    color: ${this.theme8} !important;
					}
				`;
			},
			//品牌
			getCardType() {
				getCardType().then(res => {
					if (res?.code === 200) {
						this.cardsList = res.data.map(item => ({
							label: item.label,
							value: item.value
						}));
					}
				})
			},
			//获取品牌和品牌里面的套餐
			getCardId() {
				let data = {
					cardId: this.addForm.cardId,
				};
				setMealList(data).then(res => {
					if (res?.code === 200) {
						this.setMealIdList = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},

			//获取时间
			getTime() {
				if (Array.isArray(this.timeArr) && this.timeArr.length === 2) {
					this.query.startTime = this.toDateTimeStr(this.timeArr[0]);
					this.query.endTime = this.toDateTimeStr(this.timeArr[1]);
				} else {
					this.query.startTime = '';
					this.query.endTime = '';
					this.timeArr = [];
				}
			},
			toDateTimeStr(nS) {
				let date = new Date(nS);
				let YY = date.getFullYear() + '-';
				let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
				let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
				return YY + MM + DD;
			},
			getData() {
				this.loading = true;
				whiteCardStatistics(this.query).then(res => {
					this.loading = false;
					if (res?.code === 200) {
						this.tableData = res.data.list || res.data;
						this.pageTotal = res.data.total || res.data.length;
					} else {
						this.$message.error(res.message || '获取数据失败');
					}
				}).catch(() => {
					this.loading = false;
				});
			},

			// 删除操作
			handleDelete(index, id) {
				this.$confirm('确定要关闭订单吗？', '提示', {
						type: 'warning'
					})
					.then(() => {
						closeOrder({
							id
						}).then(res => {
							if (res?.code === 200) {
								this.$message.success('关闭成功');
								this.getData();
							} else {
								this.$message.error(res.message);
							}
						});
					});
			},

			importProgress(row) {
				this.uid = row.uid;
				let data = {
					uid: row.uid,
					type: 2,
					batchNum: row.batch_num,
					startTime: '',
					endTime: ''
				};
				importOrderRecord(data).then(res => {
					if (res?.code === 200) {
						this.progressVisible = true;
						this.progressTableData = res.data;
						this.setSecondstimer = setInterval(() => {
							this.importProgress2()
						}, 1000);
					} else {
						this.$message.error(res.message);
					}
				});
			},
			importProgress2() {
				let data = {
					uid: this.uid,
					type: 2,
				};
				importOrderRecord(data).then(res => {
					if (res?.code === 200) {
						this.progressTableData = res.data;
					} else {
						this.$message.error(res.message);
					}
				});
			},
			closeDialog() {
				this.addVisible = false;
				this.addOrderVisible = false;
				this.progressVisible = false;
				clearInterval(this.setSecondstimer);
				this.setSecondstimer = null;
				this.$refs.addForm?.resetFields();
				this.$refs.addOrderForm?.resetFields();
			},
			submitAdd() {
				if (this.$refs.upload?.uploadFiles[0]) {
					this.uploading = true;
					this.$refs.upload.submit();
				} else {
					this.$message.error('请选择上传文件');
				}
			},
			getwhiteCardWrite() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.uploading = true;

					}
				});
			},
			handleAdd(row) {
				this.addVisible = true;
				this.addForm = {
					cardId: row.card_id,
					uid: row.uid,
					standard: row.standard,
					batchNum: row.batch_num,
					batchOpen: false,
				};
				setMealList({
					cardId: row.card_id
				}).then(res => {
					if (res?.code === 200) {
						this.setMealIdList = res.data
					} else {
						this.$message.error(res.message);
					}
				});
			},
			handleAddOrder() {
				this.addOrderVisible = true;
			},
			submitAddOrder() {
				this.$refs.addOrderForm.validate(valid => {
					if (valid) {
						this.uploading = true;
						const params = {
							...this.addOrderForm,
							yd: Number(this.addOrderForm.yd),
							lt: Number(this.addOrderForm.lt),
							dx: Number(this.addOrderForm.dx),
							type: Number(this.addOrderForm.type),
							price: Number(this.addOrderForm.price),
						};

						submitOrder(params).then(res => {
							this.uploading = false;
							if (res?.code === 200) {
								this.addOrderVisible = false;
								this.getData();
								this.$message.success('提交成功');
							} else {
								this.$message.error(res.message);
							}
						}).catch(() => {
							this.uploading = false;
						});
					}
				});
			},
			handleRemove() {
				// 文件移除处理
				this.$refs.addForm?.resetFields();
			},
			handlePreview() {
				// 文件预览处理
			},
			//导入上传
			uploadSuccess(response) {
				this.uploading = false;
				if (response?.code === 200) {
					this.addVisible = false;
					this.$refs.upload.clearFiles();
					this.getData();
					this.$message.success(response.data || '入库成功');
				} else {
					this.$refs.upload.clearFiles();
					this.$message.error(response.message || '入库失败');
				}
			},
			// 分页导航
			handlePageChange(val) {
				this.query.pageIndex = val;
				this.getData();
			},
			// 分页大小变化
			handleSizeChange(val) {
				this.query.pageSize = val;
				this.query.pageIndex = 1;
				this.getData();
			},
		}
	};
</script>

<style scoped>
	.handle-box {
		margin-bottom: 20px;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 10px;
	}

	.pagination {
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;
	}
</style>